import { toast } from 'react-toastify';

const CUSTOM_TOAST_CLASS = 'custom-toast';

// eslint-disable-next-line no-unused-vars
export type ToastFunction = (message: string) => void;

export const useSuccessToast = (): ToastFunction => {
  return (message: string) => {
    toast.success(message, {
      className: CUSTOM_TOAST_CLASS,
    });
  };
};

export const useErrorToast = (): ToastFunction => {
  return (message: string) => {
    toast.error(message, {
      className: CUSTOM_TOAST_CLASS,
    });
  };
};
